module.exports = __webpack_public_path__ + "img/129-ossetia.6fb316a9.svg";